<script setup lang="ts">
import {RcsCard, RcsSuggestion as IRcsSuggestion} from "@/notification-template/interfaces";
import {ref, watch} from "vue";
import RCSSuggestion from "@/notification-template/components/rcs/RCSSuggestion.vue";

const props = defineProps<{
    payload: RcsCard
}>();

const mediaIsVideo = ref<boolean | undefined>(undefined);

defineEmits<{
    (e: 'suggestionClick', suggestion: IRcsSuggestion): void
}>();

watch(() => props.payload.media_url, (url) => {
    if (!url) {
        return;
    }

    const testVideo = document.createElement('video');
    testVideo.onloadedmetadata = () => {
        mediaIsVideo.value = true;
    };
    testVideo.onerror = () => {
        mediaIsVideo.value = false;
    };
    testVideo.src = url;
}, {immediate: true});
</script>

<template>
  <div class="bg-white rounded-2xl overflow-hidden shadow-md border border-gray-200 flex flex-col">
    <video v-if="mediaIsVideo" :src="payload.media_url" controls class="w-full aspect-video" />
    <img
      v-else-if="!mediaIsVideo && payload.media_url"
      :src="payload.media_url"
      class="w-full aspect-[3/2] object-cover"
      alt="Card"
    >
    <div class="p-3">
      <p class="font-semibold mb-1 text-[12px] text-primary">
        {{ payload.title }}
      </p>
      <p class="text-gray-600 text-[11px] leading-snug whitespace-pre-wrap">
        {{ payload.content }}
      </p>
    </div>
    <div v-if="payload.suggestions?.length" class="self-start px-2 pb-2 flex flex-wrap gap-1.5">
      <RCSSuggestion v-for="(suggestion, index) in payload.suggestions ?? []" :key="index" :payload="suggestion" @click="$emit('suggestionClick', suggestion)" />
    </div>
  </div>
</template>

<style scoped>

</style>
